import { useCallback, useMemo } from "react";
import { useModuleEntitlements } from "@/application/queries";
import { useCurrentOrganizationId } from "@/hooks/organization";

export const useModuleAccess = () => {
  const orgId = useCurrentOrganizationId();
  const { data: entitlements = [], isLoading: loading } = useModuleEntitlements(orgId);

  const hasModule = useCallback(
    (code: string): boolean => entitlements.some((e) => e.module_code === code && e.is_active),
    [entitlements],
  );

  return useMemo(() => ({ entitlements, loading, hasModule }), [entitlements, loading, hasModule]);
};
